import {
  commandKeySymbol,
  optionKeySymbol,
  shiftKeySymbol,
} from '@ipfabric/frontend-shared-assets/utils/characters';
import { isApple } from './isApple';

export const cmdKey = `${commandKeySymbol} Cmd`;
export const platformAltKey = `${isApple ? `${optionKeySymbol} Option` : 'Alt'}`;
export const platformCmdOrCtrlKey = isApple ? cmdKey : 'Ctrl';
export const platformShiftKey = `${isApple ? `${shiftKeySymbol} ` : ''}Shift`;
